import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
	selector: 'app-clean-layout',
	templateUrl: './clean-layout.component.html',
	styleUrls: ['./clean-layout.component.scss']
})
export class CleanLayoutComponent implements OnInit {
	
	constructor(
	) {
	}
		
	ngOnInit() {
	}
	
}
	